export function AlertTriangleIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='12' height='13' viewBox='0 0 12 13' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M5.99988 5.04998V7.04998M5.99988 9.04998H6.00488M5.30754 2.49584L1.19509 9.59915C0.966991 9.99315 0.85294 10.1901 0.869797 10.3518C0.884499 10.4929 0.958384 10.621 1.07306 10.7044C1.20454 10.8 1.43217 10.8 1.88744 10.8H10.1123C10.5676 10.8 10.7952 10.8 10.9267 10.7044C11.0414 10.621 11.1153 10.4929 11.13 10.3518C11.1468 10.1901 11.0328 9.99315 10.8047 9.59915L6.69222 2.49584C6.46493 2.10326 6.35129 1.90697 6.20303 1.84104C6.0737 1.78354 5.92606 1.78354 5.79673 1.84104C5.64846 1.90697 5.53482 2.10326 5.30754 2.49584Z'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
